import { Navigate } from "react-router-dom";

const exportDefault = {
    checkWhatsApp(number) {
        const whatsappRegex = /^(?:\+|00)[1-9]\d{1,14}$/;
        return whatsappRegex.test(number);
    },
    checkPhone(number, isPhone = false) {
        if (isPhone) {
            const nineDigitRegex = /^0\d{8}$/;
            const thirteenDigitRegexPlus = /^(00|\+)\d{12}$/;
            const thirteenDigitRegex = /^00\d{11}$/;
            const twelveDigitRegex = /^\+\d{11}$/;
            const elevenDigitRegex = /^\d{11}$/;

            const tenDigitRegex = /^\d{10}$/;
            const fourteenDigitRegex = /^(00|\+)\d{12}$/;
            const twelveDigitRegexPlus = /^\+\d{12}$/;
            const twelveDigitRegexDigit = /^\d{12}$/;
            return (
                nineDigitRegex.test(number) ||
                thirteenDigitRegexPlus.test(number) ||
                thirteenDigitRegex.test(number) ||
                twelveDigitRegex.test(number) ||
                elevenDigitRegex.test(number) ||
                tenDigitRegex.test(number) ||
                fourteenDigitRegex.test(number) ||
                twelveDigitRegexPlus.test(number) ||
                twelveDigitRegexDigit.test(number)
            );

        }
        else {
            const tenDigitRegex = /^\d{10}$/;
            const fourteenDigitRegex = /^(00|\+)\d{12}$/;
            const twelveDigitRegexPlus = /^\+\d{12}$/;
            const twelveDigitRegex = /^\d{12}$/;
            return tenDigitRegex.test(number) || fourteenDigitRegex.test(number) || twelveDigitRegexPlus.test(number) || twelveDigitRegex.test(number);
        }
    },
    checkEmail(email) {
        let re =
            /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email + '');
    },
    logout() {
        localStorage.removeItem("traffic_user");
        localStorage.removeItem("traffic_token");
        window.location.href = "/"; // إعادة التوجيه يدويًا
    },
    validatePassword(password,t) {
        const minLength = /.{8,}/;
        const hasUpperCase = /[A-Z]/;
        const hasLowerCase = /[a-z]/;
        const hasNumber = /[0-9]/;
        const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/;

        if (!minLength.test(password)) {
            return t('lenError')
        }
        if (!hasUpperCase.test(password)) {
            return t('capitalError');
        }
        if (!hasLowerCase.test(password)) {
            return t('smallError');
        }
        if (!hasNumber.test(password)) {
            return t('numberError');
        }
        if (!hasSymbol.test(password)) {
            return t('symbolError');
        }

        return null; // ✅ Valid password
    },

}

export default exportDefault;